import { useSyncExternalStore } from 'react';

/**
 * Preferências de tela de cada pessoa, guardadas no navegador: menu lateral e
 * lista de pipelines recolhidos, e o tema (claro/escuro). Não vão para o
 * servidor — trocar de computador volta ao padrão.
 */
export interface UiPrefs {
  navCollapsed: boolean;
  pipelinesCollapsed: boolean;
  theme: 'light' | 'dark';
}

const KEY = 'crm.ui-prefs';
const DEFAULTS: UiPrefs = { navCollapsed: false, pipelinesCollapsed: false, theme: 'light' };
const listeners = new Set<() => void>();

function read(): UiPrefs {
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? { ...DEFAULTS, ...(JSON.parse(raw) as Partial<UiPrefs>) } : DEFAULTS;
  } catch {
    return DEFAULTS;
  }
}

let current = read();

/** Põe a classe `dark` no <html> — chamada no boot (antes do React) e a cada troca. */
export function applyTheme(theme: UiPrefs['theme'] = current.theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark');
  document.documentElement.style.colorScheme = theme;
}

export function setUiPrefs(patch: Partial<UiPrefs>) {
  current = { ...current, ...patch };
  try {
    window.localStorage.setItem(KEY, JSON.stringify(current));
  } catch {
    // navegador sem armazenamento: vale só nesta aba
  }
  if (patch.theme) applyTheme(patch.theme);
  for (const listener of listeners) listener();
}

export function useUiPrefs(): UiPrefs {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => current,
  );
}
